<mdi-topbar [isHome]="false"></mdi-topbar>

<div  class="container-fluid" style="margin-top: 75px; height: 80%;  width: 100%;">
    <div class="flex-row row stdTheme"
        style="height: 45px; padding: 0px; margin-left: 0px; margin-right: 0px;">

        <div class="col-2 top-sidenav"
            style="text-align: start!important">
            <button mat-raised-button
                    type="button"
                    (click)="doCancel()">
                <mat-icon>arrow_back</mat-icon>
                {{ 'goback' | translate }}
            </button>
        </div>

        <div class="col-6 top-sidenav"
            style="text-align: center!important">
            <span style="font-size:large">
                <strong>{{ 'wks_stocks_parts_delivery' | translate }}</strong>
            </span>
        </div>

        <div class="col-2 top-sidenav"
            style="text-align: center!important">
            <button mat-raised-button
                    type="button"
                    [disabled]="inputInProgress"
                    (click)="startDeliveryScanSequence()">
                <mat-icon>scanner</mat-icon>
                {{ 'scanDeliveries' | translate }}
            </button>
        </div>

        <div class="col-2 top-sidenav"
            style="text-align: end!important">
            <button [disabled]="inputInProgress"
                    mat-raised-button
                    type="button"
                    (click)="addDelivery()">
                <span class="fa fa-plus-square"
                    style="font-size: 20px"></span>
                {{ 'addDelivery' | translate }}
            </button>
        </div>
    </div>
</div>
<div *ngIf="addingDelivery || updateDelivery || videoCodingDelivery">

    <div *ngIf="videoCodingDelivery; else standardDeliveryTemplate">
        <div
            *ngIf="gedDocumentImageLoading"
            class="d-flex justify-content-center align-items-center"
            style="width: 100%; height: 100%;">
            <mat-spinner diameter="50"></mat-spinner>
        </div>

        <div
            *ngIf="!gedDocumentImageLoading"
            style="width: 100%; height: 100%;">
            <div
                *ngTemplateOutlet="
                    videoCodingCardTemplate;
                    context: { status: 'action' }
                ">
            </div>
        </div>
    </div>
    <ng-template #standardDeliveryTemplate>
        <div *ngTemplateOutlet="deliveriesCardTemplate; context: { status: 'action' }"></div>
    </ng-template>

</div>

<div *ngIf="!addingDelivery && !updateDelivery && !videoCodingDelivery">
    <div *ngTemplateOutlet="deliveriesListTemplate; context: { status: 'action' }"></div>
</div>
<ng-template #deliveriesListTemplate let-action="action" >
    <div class="flex-row row"
        style="margin-left: 10px; margin-right: 10px; margin-top: 10px; margin-bottom: 10px;">

        <div class="col-12" style="text-align: start!important;">

            <button mat-raised-button
                    type="button"
                    [disabled]="!showGedWaiting"
                    (click)="showGedWaiting = false"
                    style="margin-right: 10px;">
                <mat-icon>description</mat-icon>
                Bons de livraison
            </button>

            <button mat-raised-button
                    type="button"
                    [disabled]="showGedWaiting"
                    (click)="toggleGedWaiting()">
                <mat-icon>folder</mat-icon>
                Documents en attente
            </button>

        </div>
    </div>
    <mat-card class="register-card stdTheme" layout="column" flex style="padding-left: 0px; padding-right: 0px;">
        <!--
        <mat-card-header>
            <mat-card-title>
                <span #titleCardEl>{{ titleCard | translate }}</span>
            </mat-card-title>
        </mat-card-header>
        -->
        <mat-card-actions>
            <div class="flex-row row" style="margin-left: 10px;margin-right: 10px;margin-top: 0px;">

                <div class="col-4" *ngIf="!showGedWaiting">
                    <div class="flex-row row" style="margin: 0px; padding: 0px;">
                        <div class="col-2" style="text-align: start!important;margin-top: 30px;">
                            <button mat-icon-button
                                    class="buttonTheme"
                                    (click)="refresh()"
                                    style="margin-left: 10px;margin-right: 10px;">
                                <span class="fas fa-redo" style="font-size: 20px"></span>
                            </button>
                        </div>
                        <div class="col-8">
                            <mat-form-field class="mdiinput form-group" appearance="standard">
                                <mat-label>{{ 'bsnId' | translate }}</mat-label>
                                <mat-select id="bsnIdSelection"
                                            #bsnIdSelection
                                            panelClass="mdiselectcontent"
                                            class="warehousePanel"
                                            placeholder="{{ 'selectOneSupplier' | translate }}"
                                            [(value)]="bsnSelected"
                                            (selectionChange)="bsnSelect(bsnIdSelection.value)">
                                    <mat-option class="selectOptionsTheme"
                                                *ngFor="let supplierCur of suppliersSelection"
                                                [value]="supplierCur.id">
                                        {{supplierCur.bsnName}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-2" style="margin-top: 30px;">
                            <button mat-icon-button
                                    (click)="searchSupplier()"
                                    [disabled]="!bsnSearch">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-8"></div>
                
            </div>
        </mat-card-actions>
        <mat-card-content class="stdTheme">
            <div *ngIf="!showGedWaiting">>
                <div *ngIf="loadingIndicator" class="spinner-container  stdTheme" >
                    <div class="flex-row row d-flex justify-content-center" style="padding: 0px; margin-left: 0px; margin-right: 0px;margin-top: 50px">
                        <mat-spinner diameter="40" strokeWidth="5"></mat-spinner>
                    </div>
                    <div class="flex-row row d-flex justify-content-center" style="padding: 0px; margin-left: 0px; margin-right: 0px;margin-top: 70px">
                        <div class="loader-container">
                            <div class="loading-text">{{ 'loadingDeliveries' | translate }}<span class="dots"></span></div>
                        </div>
                    </div>
                </div>
                <div *ngIf="!loadingIndicator" class="stdTheme" >
                    <div class="flex-row row d-flex justify-content-center" style="margin-left: 0px; margin-right: 0px;overflow: hidden!important;">
                        <div class="col-4"style="margin-left: 0px; margin-right: 0px;">
                            <div class="flex-row row rowTitle w-100" style="margin-left: 0px; margin-right: 0px;">
                                <div class="col-1 d-flex justify-content-start align-items-center"></div>
                                <div class="col-2 d-flex justify-content-center align-items-center"><b>{{'deliveryDateCol' | translate}}</b></div>
                                <div class="col-2 d-flex justify-content-center align-items-center"><b>{{'deliveryRefCol' | translate}}</b></div>
                                <div class="col-4 d-flex justify-content-center align-items-center"><b>{{'supplierName' | translate}}</b></div>
                                <div class="col-2 d-flex justify-content-center align-items-center"><b>{{'orderRefCol' | translate}}</b></div>
                                <div class="col-1 d-flex justify-content-start align-items-center"></div>
                            </div>
                            <div class="lineWks" style="margin-top: 5px;"></div>
                            <div *ngIf="partsDeliveriesList.length > 0" style="height: 550px;max-height: 550px;overflow-x: hidden!important; overflow-y: auto ">
                                <div class="flex-row row "
                                    style="margin-left: 0px; margin-right: 0px;"
                                    *ngFor="let partsDelivery of partsDeliveriesList; let i = index"
                                    [class.lineOdd]="i % 2 === 0"
                                    [class.lineEven]="i % 2 === 1"
                                    [class.data-selected]="rowsDeliveries[i].isSelected">
                                    <div class="col-1 d-flex justify-content-start align-items-center">
                                        <button mat-icon-button  style="padding-top: 0px;"
                                                (click)="updateDetail(i)" [disabled]="isReadOnly"
                                                data-toggle="tooltip" data-placement="top" title="{{ 'updateDetail' | translate }}">
                                            <i class="fa fa-edit" style="font-size: 15px;" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                    <div class="col-2 d-flex align-items-center" >{{getFormatDate(partsDelivery.deliveryDate)}}</div>
                                    <div class="col-2 d-flex align-items-center" >{{partsDelivery.deliveryRef}}</div>
                                    <div class="col-4 d-flex align-items-center" >{{partsDelivery.bsnName}}</div>
                                    <div class="col-2 d-flex align-items-center" >{{partsDelivery.orderRef}}</div>
                                    <div class="col-1 d-flex justify-content-start align-items-center">
                                        <button mat-icon-button  style="padding-top: 0px;"
                                                (click)="lineDetail(i)" [disabled]="isReadOnly"
                                                data-toggle="tooltip" data-placement="top" title="{{ 'lineDetail' | translate }}">
                                            <i class="fa fa-list-ol" style="font-size: 15px;" aria-hidden="true"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-8"style="margin-left: 0px; margin-right: 0px;">
                            <div *ngIf="idxSelected > -1 && !rowsDeliveries[idxSelected].isCollapsed && rowsDeliveries[idxSelected].isSelected && partsDeliveriesDetailList && partsDeliveriesDetailList.length > 0">
                                <div class="flex-row row rowTitle w-100" style="margin-left: 0px; margin-right: 0px;">
                                    <div class="col-2 d-flex justify-content-center align-items-center"><b>{{'brandRef' | translate}}</b></div>
                                    <div class="col-3 d-flex justify-content-center align-items-center"><b>{{'brandLabel' | translate}}</b></div>
                                    <div class="col-1 d-flex justify-content-center align-items-center"><b>{{'Id' | translate}}</b></div>
                                    <div class="col-1 d-flex justify-content-center align-items-center"><b>{{'partQty' | translate}}</b></div>
                                    <div class="col-1 d-flex justify-content-center align-items-center"><b>{{'supplierPackaging' | translate}}</b></div>
                                    <div class="col-1 d-flex justify-content-center align-items-center"><b>{{'partPurchase' | translate}}</b></div>
                                    <div class="col-1 d-flex justify-content-center align-items-center"><b>{{'partSelling' | translate}}</b></div>
                                </div>
                                <div class="lineWks" style="margin-top: 5px;"></div>
                                <div *ngIf="partsDeliveriesDetailList.length > 0" style="height: 550px;max-height: 550px;overflow-x: hidden!important; overflow-y: auto ">
                                    <div class="flex-row row "
                                        style="margin-left: 0px; margin-right: 0px;"
                                        *ngFor="let partsDeliveryItem of partsDeliveriesDetailList; let ix = index"
                                        [class.lineOdd]="ix % 2 === 0"
                                        [class.lineEven]="ix % 2 === 1">
                                        <div class="col-2 d-flex align-items-center">{{partsDeliveryItem.brandRef}}</div>
                                        <div class="col-3 d-flex align-items-center">{{datasDeliveryDetail[ix].brandLabel}}</div>
                                        <div class="col-1 d-flex align-items-center">{{partsDeliveryItem.stockId}}</div>
                                        <div class="col-1 d-flex justify-content-end align-items-center">{{partsDeliveryItem.partQty | formatNumber : ['quantity',numberFormat.locale,numberFormat.minDecimal, numberFormat.maxDecimal ]}}</div>
                                        <div class="col-1 d-flex justify-content-end align-items-center">{{partsDeliveryItem.supplierPackaging | formatNumber : ['quantity',numberFormat.locale,numberFormat.minDecimal, numberFormat.maxDecimal ]}}</div>
                                        <div class="col-1 d-flex justify-content-end align-items-center">{{partsDeliveryItem.partPurchase | formatNumber : ['currency',numberFormat.locale,numberFormat.currency,'symbol']}}</div>
                                        <div class="col-1 d-flex justify-content-end align-items-center">{{partsDeliveryItem.partSelling | formatNumber : ['currency',numberFormat.locale,numberFormat.currency,'symbol']}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <div *ngIf="showGedWaiting">
                <!-- nouvelle liste WAITING -->
                <div class="flex-row row d-flex justify-content-center"
                    style="margin-left: 0px; margin-right: 0px; overflow: hidden!important;">
                    <div class="col-4"
                        style="margin-left: 0px; margin-right: 0px;">
                        <!-- En-tête -->
                        <div class="flex-row row rowTitle w-100"
                            style="margin-left: 0px; margin-right: 0px;">
                            <div class="col-6 d-flex align-items-center">
                                <b>Document</b>
                            </div>
                            <div class="col-2 d-flex align-items-center">
                                <b>Date</b>
                            </div>
                            <div class="col-2 d-flex justify-content-center align-items-center">
                                <b>Statut</b>
                            </div>
                            <div class="col-2 d-flex justify-content-center align-items-center">
                                <b>Actions</b>
                            </div>
                        </div>
                        <div class="lineWks"
                            style="margin-top: 5px;">
                        </div>
                        <!-- Liste -->
                        <div *ngIf="gedDocumentsWaiting.length > 0"
                            style="height: 550px;
                                    max-height: 550px;
                                    overflow-x: hidden!important;
                                    overflow-y: auto;">
                            <div class="flex-row row"
                                style="margin-left: 0px; margin-right: 0px;"
                                *ngFor="let document of gedDocumentsWaiting; let i = index"
                                [class.lineOdd]="i % 2 === 0"
                                [class.lineEven]="i % 2 === 1">
                                <div class="col-6 d-flex align-items-center">
                                    {{ document.documentName }}
                                </div>
                                <div class="col-2 d-flex align-items-center">
                                    {{ document.documentDate
                                        ? getFormatDate(document.documentDate)
                                        : '' }}
                                </div>
                                <div class="col-2 d-flex justify-content-center align-items-center">
                                    {{ document.processingStatus }}
                                </div>
                                <div class="col-2 d-flex justify-content-center align-items-center">
                                    <!-- Image -->
                                    <button mat-icon-button
                                            type="button"
                                            title="Voir le document"
                                            (click)="viewGedDocument(document)">
                                        <mat-icon>image</mat-icon>
                                    </button>
                                    <!-- Vidéo-codage -->
                                    <button mat-icon-button
                                            type="button"
                                            title="Vidéo-codage"
                                            (click)="startVideoCoding(document)">
                                        <mat-icon>edit</mat-icon>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="gedDocumentsWaiting.length === 0"
                            style="text-align: center; margin-top: 30px;">
                            Aucun document en attente.
                        </div>
                    </div>
                    <div class="col-8">
                        <div *ngIf="gedDocumentImageVisible && gedDocumentImage"
                            style="padding: 10px;">
                            <div class="d-flex justify-content-between align-items-center">
                                <b>{{ gedDocumentImage.documentName }}</b>
                                <div>
                                    <button mat-icon-button
                                            type="button"
                                            title="Zoom arrière"
                                            (click)="zoomGedDocumentOut()">
                                        <mat-icon>remove</mat-icon>
                                    </button>

                                    <button mat-button
                                            type="button"
                                            title="Taille normale"
                                            (click)="resetGedDocumentZoom()">
                                        {{ (gedDocumentImageZoom * 100) | number:'1.0-0' }} %
                                    </button>

                                    <button mat-icon-button
                                            type="button"
                                            title="Zoom avant"
                                            (click)="zoomGedDocumentIn()">
                                        <mat-icon>add</mat-icon>
                                    </button>

                                    <button mat-icon-button
                                            type="button"
                                            title="Fermer"
                                            (click)="closeGedDocumentImage()">
                                        <mat-icon>close</mat-icon>
                                    </button>
                                </div>

                            </div>

                            <div class="lineWks"
                                style="margin-top: 5px; margin-bottom: 10px;">
                            </div>

                            <div style="
                                    width: 100%;
                                    height: 550px;
                                    overflow: auto;
                                    display: block;
                                ">

                                <div *ngIf="gedDocumentImageLoading"
                                    style="
                                        height: 100%;
                                        display: flex;
                                        justify-content: center;
                                        align-items: center;
                                    ">

                                    <mat-spinner diameter="50"></mat-spinner>

                                </div>

                                <div *ngIf="!gedDocumentImageLoading"
                                    style="
                                        width: 100%;
                                        min-height: 100%;
                                        display: flex;
                                        justify-content: flex-start;
                                        align-items: flex-start;
                                    ">

                                    <img *ngIf="gedDocumentImageSafeUrl"
                                        [src]="gedDocumentImageSafeUrl"
                                        [alt]="gedDocumentImage.documentName"
                                        [style.width.%]="100 * gedDocumentImageZoom"
                                        style="
                                            height: auto;
                                            object-fit: contain;
                                            display: block;
                                        ">

                                </div>

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</ng-template>
<ng-template #deliveriesCardTemplate let-action="action" >
    <div class="flex-row row  stdTheme w-100" style="padding: 0px; margin-left: 10px; margin-right: 10px;">
        <div *ngIf="!scanCodeActivate" class="col-1 d-flex justify-content-center" style="padding: 0px; margin-left: 0px; margin-right: 0px;"></div>
        <div class="col-12 d-flex justify-content-center w-100" style="padding: 0px; margin-left: 0px; margin-right: 0px;">
            <form [formGroup]="partDeliveryForm"  class="w-100" >
                <mat-card appMaterialElevation class="register-card stdTheme w-100" layout="column" flex style="padding: 0px; padding-right: 5px; padding-left: 5px;">
                    <mat-card-header>
                        <mat-card-title>
                        <section class="mat-typography">
                            <h1 class="titleTheme" style="padding-top: 10px;">{{ titleCard | translate }}</h1>
                        </section>
                        </mat-card-title>
                    </mat-card-header>
                    <mat-card-actions>
                        <div class="container-fluid d-flex justify-content-center" >
                            <div class="flex-row row w-100" style="padding: 0px; margin-left: 0px; margin-right: 0px;" >
                                <div class="col-1 d-flex justify-content-center" style="padding: 0px">
                                    <button mat-raised-button  #buttonSubmit type="submit" (click)="cancelPartsDelivery()" >
                                        <mat-icon>cancel</mat-icon>
                                        {{ 'cancel' | translate }}
                                    </button>
                                </div>
                                <div class="col-10 d-flex justify-content-center" >
                                    <div class="alert alert-danger alert-custom" style="height: 20px" *ngIf="showAlert">
                                        {{ alertMessage }}
                                        <button type="button" class="close" (click)="closeAlert()">&times;</button>
                                    </div>
                                </div>
                                <div class="col-1 d-flex justify-content-center" style="padding: 0px" >
                                    <button [disabled]="!doRegister" mat-raised-button  #buttonSubmit type="submit" (click)="registerPartsDelivery()" >
                                        <mat-icon>save</mat-icon>
                                        {{ 'save' | translate }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </mat-card-actions>
                    <mat-card-content class="stdTheme" style="padding-bottom: 20px;">
                        <form [formGroup]="partDeliveryForm">
                            <div class="flex-row row">
                                <div class="col-3">
                                    <div class="flex-row row">
                                        <div class="col-12">
                                            <label for="deliveryDate">
                                                {{ 'deliveryDate' | translate }}
                                            </label>
                                            <div class="input-group">
                                                <input
                                                    style="text-align: center;"
                                                    required
                                                    type="text"
                                                    placeholder="{{datePickerConfig.dateInputFormat}}"
                                                    class="form-control inputTheme"
                                                    bsDatepicker
                                                    formControlName="deliveryDateFc"
                                                    #dp="bsDatepicker"
                                                    [minDate]="minDate"
                                                    [maxDate]="maxDate"
                                                    [bsConfig]="datePickerConfig"
                                                    readonly>
                                                <div class="input-group-append">
                                                    <button
                                                        class="btn btn-outline-secondary"
                                                        type="button"
                                                        (click)="dp.toggle()">
                                                        <i class="fa fa fa-calendar" style="font-size: 24px;" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="flex-row row" >
                                        <div class="col-12" >
                                            <mat-form-field class="mdiinput form-group" appearance="standard">
                                                <mat-label>{{ 'warehouse' | translate }}</mat-label>
                                                <mat-select id="warehouse" #warehouse panelClass="mdiselectcontent"
                                                    class="warehousePanel" formControlName="warehouseFc"
                                                    (selectionChange)="warehouseChoice(warehouse.value)">
                                                    <mat-option class="selectOptionsTheme" *ngFor="let warehouseCur of wareHousesList"
                                                        [value]="warehouseCur.warehouseId"> {{warehouseCur.warehouseRef}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="flex-row row">
                                        <div class="col-11">
                                            <mat-form-field class="mdiinput form-group" appearance="standard">
                                                <mat-label>{{ 'bsnId' | translate }}</mat-label>
                                                <mat-select id="bsnId" #bsnId panelClass="mdiselectcontent"
                                                    class="warehousePanel" formControlName="bsnIdFc"
                                                    (ngModelChange)="bsnChoice(bsnId.value)">
                                                    <mat-option class="selectOptionsTheme" *ngFor="let supplierCur of suppliersList"
                                                        [value]="supplierCur.id"> {{supplierCur.bsnName}}
                                                    </mat-option>
                                                </mat-select>
                                                <button mat-icon-button
                                                    matTooltip="{{ 'createSupplier' | translate }}"
                                                    matTooltipPosition="above"
                                                    matSuffix
                                                    type="button"
                                                    (click)="addSupplier($event)">
                                                    <mat-icon>add</mat-icon>
                                                </button>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="flex-row row">
                                        <div class="col-12">
                                            <mat-form-field class="mdiinput form-group" appearance="standard">
                                                <mat-label>{{ 'deliveryRef' | translate }}</mat-label>
                                                <input id="deliveryRef" class="form-control inputTheme" #deliveryRef formControlName="deliveryRefFc"
                                                    matInput
                                                    required >
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="flex-row row">
                                        <div class="col-12">
                                            <mat-form-field class="mdiinput form-group" appearance="standard">
                                                <mat-label>{{ 'orderRef' | translate }}</mat-label>
                                                <input id="orderRef" class="form-control inputTheme" #orderRef formControlName="orderRefFc"
                                                    matInput
                                                    >
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-9" >
                                    <div class="flex-row row rowTitle w-100" style="margin-left: 0px; margin-right: 0px;">
                                        <div class="col-3 ">
                                            <div class="flex-row row rowTitle w-100" style="margin: 5px">
                                                <div class="col-2 d-flex justify-content-end align-items-center"></div>
                                                <ng-container *ngIf="scanCodeActivate; else noBarcode">
                                                    <div class="col-4 d-flex text-mutedjustify-content-end align-items-center">
                                                        <b>{{ 'barcode' | translate }}</b>
                                                    </div>
                                                    <div class="col-5 d-flex justify-content-center align-items-center">
                                                        <b>{{ 'brandRef' | translate }}</b>
                                                    </div>
                                                </ng-container>

                                                <ng-template #noBarcode>
                                                    <div class="col-4 d-flex justify-content-end align-items-center">
                                                        <b class="text-muted" >{{ 'barcode' | translate }}</b>
                                                    </div>
                                                    <div class="col-5 d-flex justify-content-center align-items-center">
                                                        <b>{{ 'brandRef' | translate }}</b>
                                                    </div>
                                                </ng-template>
                                            </div>
                                        </div>
                                        <div class="col-1 d-flex justify-content-center align-items-center"></div>
                                        <div class="col-2 d-flex justify-content-center align-items-center"><b>{{'brandLabel' | translate}}</b></div>
                                        <div class="col-1 d-flex justify-content-center align-items-center"><b>{{'Id' | translate}}</b></div>
                                        <div class="col-1 d-flex justify-content-center align-items-center"><b>{{'partQty' | translate}}</b></div>
                                        <div class="col-1 d-flex justify-content-center align-items-center"><b>{{'supplierPackaging' | translate}}</b></div>
                                        <div class="col-1 d-flex justify-content-center align-items-center"><b>{{'partPurchase' | translate}}</b></div>
                                        <div class="col-1 d-flex justify-content-center align-items-center"><b>{{'coef' | translate}}</b></div>
                                        <div class="col-1 d-flex justify-content-center align-items-center">
                                            <b>{{'partSelling' | translate}}</b>
                                            <button mat-icon-button style="padding-top: 0px;"
                                                    (click)="addRowPartsFa()" [disabled]="isReadOnly"
                                                    data-toggle="tooltip" data-placement="top" title="{{ 'add tooltip' | translate }}">
                                                <span class="fa fa-plus" style="font-size: 15px;" aria-hidden="true"></span>
                                            </button>
                                        </div>
                                    </div>
                                    <div formArrayName="rowsPartsFa" >
                                        <div style="overflow-x: hidden!important; overflow-y: auto!important; height: 550px!important; max-height: 550px!important;">
                                            <div *ngFor="let rowPart of rowsPartsFa.controls; let idxRow_1=index" [formGroupName]="idxRow_1">
                                                <div class="flex-row row d-flex align-items-center rowHoursUsage " style="margin: 5px">
                                                    <div class="col-3 " style="padding-left: 0px;padding-right: 0px;">
                                                        <div class="flex-row row rowTitle w-100" style="margin-left: 0px; margin-right: 0px;">
                                                            <div class="col-2 d-flex justify-content-center" style="padding-left: 0px;padding-right: 0px;">
                                                                <button mat-icon-button style="padding-top: 0px;margin-top: 25px;"
                                                                        (click)="removeRowPartsFa(idxRow_1)" [disabled]="isReadOnly || rowsParts[idxRow_1]?.partStatut === 'recorded'"
                                                                        data-toggle="tooltip" data-placement="top" title="{{'delete row' | translate }}">
                                                                    <span class="fa fa-trash" style="font-size: 15px;" aria-hidden="true"></span>
                                                                </button>
                                                            </div>
                                                            <ng-container *ngIf="scanCodeActivate; else noBarcode">
                                                                <div class="col-4 d-flex text-muted justify-content-end align-items-center" style="padding-left: 0px;padding-right: 0px;">
                                                                    <mat-form-field class="mdiinput form-group" appearance="standard">
                                                                        <mat-label>{{ 'barcode' | translate }} </mat-label>
                                                                        <input id="'barcode_' + idxRow_1" class="form-control inputTheme" formControlName="barcodeFc"
                                                                            matInput readonly>
                                                                        <button mat-icon-button matSuffix *ngIf="rowsPartsFa.at(idxRow_1).get('barcodeFc')?.value"
                                                                                style="height: 100%;margin-top : 30px"
                                                                                aria-label="Clear"
                                                                                (click)="clearBarcode(idxRow_1)">
                                                                            <mat-icon>close</mat-icon>
                                                                        </button>
                                                                    </mat-form-field>
                                                                </div>

                                                                <div class="col-6 d-flex justify-content-center align-items-center" style="padding-right: 0px;">
                                                                    <mat-form-field class="mdiinput form-group" appearance="standard">
                                                                        <mat-label>{{ 'brandRef' | translate }} </mat-label>
                                                                        <input id="'brandRef_' + idxRow_1" class="form-control inputTheme" formControlName="brandRefFc"
                                                                            matInput
                                                                            required>
                                                                        <button mat-icon-button matSuffix *ngIf="rowsPartsFa.at(idxRow_1).get('brandRefFc')?.value"
                                                                                style="height: 100%;margin-top : 30px"
                                                                                aria-label="Clear"
                                                                                (click)="clearBrandRef(idxRow_1)">
                                                                            <mat-icon>close</mat-icon>
                                                                        </button>
                                                                    </mat-form-field>
                                                                </div>
                                                            </ng-container>

                                                            <ng-template #noBarcode>
                                                                <div class="col-4 d-flex justify-content-end align-items-center" style="padding-left: 0px;padding-right: 0px;">
                                                                    <mat-form-field class="mdiinput form-group" appearance="standard">
                                                                        <mat-label>{{ 'barcode' | translate }} </mat-label>
                                                                        <input id="'barcode_' + idxRow_1" class="form-control inputTheme" formControlName="barcodeFc"
                                                                            matInput readonly>
                                                                        <button mat-icon-button matSuffix *ngIf="rowsPartsFa.at(idxRow_1).get('barcodeFc')?.value"
                                                                                style="height: 100%;margin-top : 30px"
                                                                                aria-label="Clear"
                                                                                (click)="clearBarcode(idxRow_1)">
                                                                            <mat-icon>close</mat-icon>
                                                                        </button>
                                                                    </mat-form-field>
                                                                </div>
                                                                <div class="col-6 d-flex justify-content-center align-items-center" style="padding-right: 0px;">
                                                                    <mat-form-field class="mdiinput form-group" appearance="standard">
                                                                        <mat-label>{{ 'brandRef' | translate }} </mat-label>
                                                                        <input id="'brandRef_' + idxRow_1" class="form-control inputTheme" formControlName="brandRefFc"
                                                                            matInput
                                                                            required>
                                                                        <button mat-icon-button matSuffix *ngIf="rowsPartsFa.at(idxRow_1).get('brandRefFc')?.value"
                                                                                style="height: 100%;margin-top : 30px"
                                                                                aria-label="Clear"
                                                                                (click)="clearBrandRef(idxRow_1)">
                                                                            <mat-icon>close</mat-icon>
                                                                        </button>
                                                                    </mat-form-field>
                                                                </div>
                                                            </ng-template>
                                                        </div>
                                                    </div>

                                                    <div class="col-1 d-flex justify-content-center align-items-center" style="height: 100%;margin-top : 30px; padding-left: 0px;padding-right: 0px;">
                                                        <div *ngIf="scanCodeActivate && !rowsParts[idxRow_1]?.isFound">
                                                            <button mat-icon-button
                                                                    (click)="addReference(idxRow_1)" [disabled]="isReadOnly">
                                                                <i class="fa fa-plus"></i>
                                                            </button>
                                                            <button mat-icon-button
                                                                    (click)="searchReference(idxRow_1)" [disabled]="isReadOnly">
                                                                <i class="fa fa-search"></i>
                                                            </button>
                                                        </div>
                                                        <div *ngIf="!scanCodeActivate && !rowsParts[idxRow_1]?.isFound">
                                                            <button *ngIf="rowsParts[idxRow_1]?.toCreate; else searchIcon" mat-icon-button
                                                                    (click)="addReference(idxRow_1)" [disabled]="isReadOnly">
                                                                <i class="fa fa-plus"></i>
                                                            </button>
                                                            <ng-template #searchIcon>
                                                                <button mat-icon-button
                                                                    (click)="searchReference(idxRow_1)" [disabled]="isReadOnly">
                                                                    <i class="fa fa-search"></i>
                                                                </button>
                                                            </ng-template>
                                                        </div>
                                                    </div>

                                                    <div class="col-2">
                                                        <mat-form-field class="mdiinput form-group" appearance="standard">
                                                            <mat-label>{{ 'brandLabel' | translate }}</mat-label>
                                                            <input id="'brandLabel_' + idxRow_1" class="form-control inputTheme" formControlName="brandLabelFc"
                                                                matInput
                                                                required
                                                                readonly>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-1">
                                                        <mat-form-field class="mdiinput form-group" appearance="standard">
                                                            <mat-label>{{ 'Id' | translate }}</mat-label>
                                                            <input id="'stockId_' + idxRow_1" class="form-control inputTheme text-center" formControlName="stockIdFc"
                                                                matInput
                                                                required
                                                                readonly>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-1">
                                                        <mat-form-field class="mdiinput form-group" appearance="standard">
                                                            <mat-label>{{ 'partQty' | translate }}</mat-label>
                                                            <input id="'partQty_' + idxRow_1" class="form-control inputTheme" formControlName="partQtyFc"
                                                                matInput
                                                                required
                                                                style="text-align: right"
                                                                (keypress)="numberAndDotOnly($event)"
                                                                (keydown.enter)="handleEnter($event)"
                                                                (focus)="unformatNumericField('partQty', idxRow_1)"
                                                                (focusout)="formatNumericField('partQty', idxRow_1)">
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-1">
                                                        <mat-form-field class="mdiinput form-group" appearance="standard">
                                                            <mat-label>{{ 'supplierPackaging' | translate }}</mat-label>
                                                            <input id="'supplierPackaging' + idxRow_1" class="form-control inputTheme" formControlName="supplierPackagingFc"
                                                                matInput
                                                                required
                                                                style="text-align: right"
                                                                (keypress)="numberAndDotOnly($event)"
                                                                (keydown.enter)="handleEnter($event)"
                                                                (focus)="unformatNumericField('supplierPackaging', idxRow_1)"
                                                                (focusout)="formatNumericField('supplierPackaging', idxRow_1)">
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-1">
                                                        <mat-form-field class="mdiinput form-group" appearance="standard">
                                                            <mat-label>{{ 'partPurchase' | translate }}</mat-label>
                                                            <input id="'partPurchase_' + idxRow_1" class="form-control inputTheme" formControlName="partPurchaseFc"
                                                                matInput
                                                                style="text-align: right"
                                                                (keypress)="numberAndDotOnly($event)"
                                                                (keydown.enter)="handleEnter($event)"
                                                                (focus)="unformatNumericField('partPurchase', idxRow_1)"
                                                                (focusout)="formatNumericField('partPurchase', idxRow_1)">
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-1">
                                                        <mat-form-field class="mdiinput form-group" appearance="standard">
                                                            <mat-label>{{ 'coef' | translate }}</mat-label>
                                                            <input id="'coef_' + idxRow_1" class="form-control inputTheme" formControlName="coefFc"
                                                                matInput
                                                                required
                                                                style="text-align: right"
                                                                (keypress)="numberAndDotOnly($event)"
                                                                (keydown.enter)="handleEnter($event)"
                                                                (focus)="unformatNumericField('coef', idxRow_1)"
                                                                (focusout)="formatNumericField('coef', idxRow_1)">
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-1">
                                                        <mat-form-field class="mdiinput form-group" appearance="standard">
                                                            <mat-label>{{ 'partSelling' | translate }}</mat-label>
                                                            <input id="'partSelling_' + idxRow_1" class="form-control inputTheme" formControlName="partSellingFc"
                                                                matInput
                                                                style="text-align: right"
                                                                (keypress)="numberAndDotOnly($event)"
                                                                (keydown.enter)="handleEnter($event)"
                                                                (focus)="unformatNumericField('partSelling', idxRow_1)"
                                                                (focusout)="formatNumericField('partSelling', idxRow_1)">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </mat-card-content>
                </mat-card>
            </form>
        </div>
        <div *ngIf="!scanCodeActivate" class="col-1 d-flex justify-content-center" style="padding: 0px; margin-left: 0px; margin-right: 0px;"></div>
    </div>
</ng-template>
<ng-template #videoCodingCardTemplate let-action="action">
    <div class="flex-row row stdTheme w-100" style="padding:0px;margin-left:0px;margin-right:0px;box-sizing:border-box;">
        <div class="col-12 d-flex justify-content-center w-100" style="padding:0px;margin-left:0px;margin-right:0px;">
            <form [formGroup]="partDeliveryForm" class="w-100">
                <mat-card appMaterialElevation class="register-card stdTheme w-100" layout="column" flex style="padding:0px;padding-right:5px;padding-left:5px;">
                    <mat-card-header>
                        <mat-card-title>
                            <section class="mat-typography">
                                <h1 class="titleTheme" style="padding-top:10px;">{{ titleCard | translate }}</h1>
                            </section>
                        </mat-card-title>
                    </mat-card-header>

                    <mat-card-actions>
                        <div class="container-fluid d-flex justify-content-center">
                            <div class="flex-row row w-100" style="padding:0px;margin-left:0px;margin-right:0px;">
                                <div class="col-1 d-flex justify-content-center" style="padding:0px;">
                                    <button mat-raised-button #buttonSubmit type="button" (click)="cancelPartsDelivery()">
                                        <mat-icon>cancel</mat-icon>
                                        {{ 'cancel' | translate }}
                                    </button>
                                </div>
                                <div class="col-9 d-flex justify-content-center">
                                    <div class="alert alert-danger alert-custom" style="height:20px" *ngIf="showAlert">
                                        {{ alertMessage }}
                                        <button type="button" class="close" (click)="closeAlert()">&times;</button>
                                    </div>
                                </div>
                                <div class="col-2 d-flex justify-content-center" style="padding:0px;gap:10px;">
                                    <button mat-raised-button type="button" (click)="processVideoCodingDocument()" [disabled]="videoCodingProcessing || !partDeliveryForm.get('bsnIdFc')?.value">
                                        <mat-spinner *ngIf="videoCodingProcessing" diameter="20"></mat-spinner>
                                        <ng-container *ngIf="!videoCodingProcessing">
                                            <mat-icon>document_scanner</mat-icon>
                                            {{ 'processing' | translate }}
                                        </ng-container>
                                    </button>
                                    <button [disabled]="!doRegister || videoCodingProcessing" mat-raised-button #buttonSubmit type="button" (click)="registerPartsDelivery()">
                                        <mat-icon>save</mat-icon>
                                        {{ 'validationOCR' | translate }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </mat-card-actions>

                    <mat-card-content class="stdTheme" style="width:100%;height:calc(100vh - 230px);min-height:0;padding-bottom:20px;box-sizing:border-box;overflow:hidden;">
                        <div class="video-coding-content">

                            <div class="video-coding-document">
                                <fieldset class="video-coding-fieldset">
                                    <legend class="d-flex justify-content-between align-items-center">
                                        <span>{{ 'documentOCR' | translate }}</span>
                                        <span *ngIf="gedDocumentVideoCoding">
                                            <button mat-icon-button type="button" title="Zoom arrière" (click)="zoomGedDocumentOut()">
                                                <mat-icon>remove</mat-icon>
                                            </button>
                                            <button mat-button type="button" title="Taille normale" (click)="resetGedDocumentZoom()">
                                                {{ (gedDocumentImageZoom * 100) | number:'1.0-0' }} %
                                            </button>
                                            <button mat-icon-button type="button" title="Zoom avant" (click)="zoomGedDocumentIn()">
                                                <mat-icon>add</mat-icon>
                                            </button>
                                        </span>
                                    </legend>
                                    <div style="width:100%;height:100%;min-height:0;overflow:auto;">
                                        <div style="width:100%;min-width:100%;min-height:100%;display:flex;justify-content:flex-start;align-items:flex-start;">
                                            <div *ngIf="gedDocumentImageLoading" style="width:100%;height:100%;display:flex;justify-content:center;align-items:center;">
                                                <mat-spinner diameter="50"></mat-spinner>
                                            </div>
                                            <img *ngIf="gedDocumentImageSafeUrl && !gedDocumentImageLoading" [src]="gedDocumentImageSafeUrl" [alt]="gedDocumentVideoCoding?.documentName" [style.width.%]="100 * gedDocumentImageZoom" style="height:auto;object-fit:contain;display:block;">
                                        </div>
                                    </div>
                                </fieldset>
                            </div>

                            <div class="video-coding-header">
                                <fieldset class="video-coding-fieldset">
                                    <legend>{{ 'deliveryOCR' | translate }}</legend>
                                    <div class="flex-row row w-100" style="margin:0px;padding:5px;">
                                        <div class="col-2">
                                            <label for="deliveryDate">{{ 'deliveryDate' | translate }}</label>
                                            <div class="input-group">
                                                <input style="text-align:center;" required type="text" placeholder="{{datePickerConfig.dateInputFormat}}" class="form-control inputTheme" bsDatepicker formControlName="deliveryDateFc" #dp="bsDatepicker" [minDate]="minDate" [maxDate]="maxDate" [bsConfig]="datePickerConfig" readonly>
                                                <div class="input-group-append">
                                                    <button class="btn btn-outline-secondary" type="button" (click)="dp.toggle()">
                                                        <i class="fa fa fa-calendar" style="font-size:24px;" aria-hidden="true"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-2">
                                            <mat-form-field class="mdiinput form-group" appearance="standard">
                                                <mat-label>{{ 'warehouse' | translate }}</mat-label>
                                                <mat-select id="warehouse" #warehouse panelClass="mdiselectcontent" class="warehousePanel" formControlName="warehouseFc" (selectionChange)="warehouseChoice(warehouse.value)">
                                                    <mat-option class="selectOptionsTheme" *ngFor="let warehouseCur of wareHousesList" [value]="warehouseCur.warehouseId">
                                                        {{ warehouseCur.warehouseRef }}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-3">
                                            <mat-form-field class="mdiinput form-group" appearance="standard">
                                                <mat-label>{{ 'bsnId' | translate }}</mat-label>
                                                <mat-select id="bsnId" #bsnId panelClass="mdiselectcontent" class="warehousePanel" formControlName="bsnIdFc" (ngModelChange)="bsnChoice(bsnId.value)">
                                                    <mat-option class="selectOptionsTheme" *ngFor="let supplierCur of suppliersList" [value]="supplierCur.id">
                                                        {{ supplierCur.bsnName }}
                                                    </mat-option>
                                                </mat-select>
                                                <button mat-icon-button matTooltip="{{ 'createSupplier' | translate }}" matTooltipPosition="above" matSuffix type="button" (click)="addSupplier($event)">
                                                    <mat-icon>add</mat-icon>
                                                </button>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-2">
                                            <mat-form-field class="mdiinput form-group" appearance="standard">
                                                <mat-label>{{ 'deliveryRef' | translate }}</mat-label>
                                                <input id="deliveryRef" class="form-control inputTheme" formControlName="deliveryRefFc" matInput required>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-3">
                                            <mat-form-field class="mdiinput form-group" appearance="standard">
                                                <mat-label>{{ 'orderRef' | translate }}</mat-label>
                                                <input id="orderRef" class="form-control inputTheme" formControlName="orderRefFc" matInput>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>

                            <div class="video-coding-lines">
                                <fieldset class="video-coding-fieldset">
                                    <legend>{{ 'partsOCR' | translate }}</legend>
                                    <div class="flex-row row rowTitle w-100" style="margin:0px;padding:5px 0px;">
                                        <div class="col-3">
                                            <div class="flex-row row rowTitle w-100" style="margin:5px">
                                                <div class="col-2"></div>
                                                <div class="col-4 d-flex justify-content-end align-items-center">
                                                    <b>{{ 'barcode' | translate }}</b>
                                                </div>
                                                <div class="col-6 d-flex justify-content-center align-items-center">
                                                    <b>{{ 'brandRef' | translate }}</b>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-1"></div>
                                        <div class="col-2 d-flex justify-content-center align-items-center"><b>{{ 'brandLabel' | translate }}</b></div>
                                        <div class="col-1 d-flex justify-content-center align-items-center"><b>{{ 'Id' | translate }}</b></div>
                                        <div class="col-1 d-flex justify-content-center align-items-center"><b>{{ 'partQty' | translate }}</b></div>
                                        <div class="col-1 d-flex justify-content-center align-items-center"><b>{{ 'supplierPackaging' | translate }}</b></div>
                                        <div class="col-1 d-flex justify-content-center align-items-center"><b>{{ 'partPurchase' | translate }}</b></div>
                                        <div class="col-1 d-flex justify-content-center align-items-center"><b>{{ 'coef' | translate }}</b></div>
                                        <div class="col-1 d-flex justify-content-center align-items-center">
                                            <b>{{ 'partSelling' | translate }}</b>
                                            <button mat-icon-button type="button" style="padding-top:0px;" (click)="addRowPartsFa()" [disabled]="isReadOnly" title="{{ 'add tooltip' | translate }}">
                                                <span class="fa fa-plus" style="font-size:15px;" aria-hidden="true"></span>
                                            </button>
                                        </div>
                                    </div>

                                    <div formArrayName="rowsPartsFa" style="height:calc(100% - 45px);min-height:0;overflow:hidden;">
                                        <div style="width:100%;height:100%;overflow-x:auto;overflow-y:auto;">
                                            <div *ngFor="let rowPart of rowsPartsFa.controls; let idxRow_1=index" [formGroupName]="idxRow_1">
                                                <div class="flex-row row d-flex align-items-center rowHoursUsage" style="margin:5px">
                                                    <div class="col-3" style="padding-left:0px;padding-right:0px;">
                                                        <div class="flex-row row rowTitle w-100" style="margin-left:0px;margin-right:0px;">
                                                            <div class="col-2 d-flex justify-content-center" style="padding-left:0px;padding-right:0px;">
                                                                <button mat-icon-button type="button" style="padding-top:0px;margin-top:25px;" (click)="removeRowPartsFa(idxRow_1)" 
                                                                        [disabled]="isReadOnly || rowsParts[idxRow_1]?.partStatut === 'recorded'" title="{{ 'delete row' | translate }}">
                                                                    <span class="fa fa-trash" style="font-size:15px;" aria-hidden="true"></span>
                                                                </button>
                                                            </div>
                                                            <div class="col-4 d-flex justify-content-end align-items-center" style="padding-left:0px;padding-right:0px;">
                                                                <mat-form-field class="mdiinput form-group" appearance="standard">
                                                                    <mat-label>{{ 'barcode' | translate }}</mat-label>
                                                                    <input class="form-control inputTheme" formControlName="barcodeFc" matInput readonly>
                                                                    <button mat-icon-button matSuffix type="button" *ngIf="rowsPartsFa.at(idxRow_1).get('barcodeFc')?.value" style="height:100%;margin-top:30px" (click)="clearBarcode(idxRow_1)">
                                                                        <mat-icon>close</mat-icon>
                                                                    </button>
                                                                </mat-form-field>
                                                            </div>
                                                            <div class="col-6 d-flex justify-content-center align-items-center" style="padding-right:0px;">
                                                                <mat-form-field class="mdiinput form-group" appearance="standard">
                                                                    <mat-label>{{ 'brandRef' | translate }}</mat-label>
                                                                    <input class="form-control inputTheme" formControlName="brandRefFc" matInput required>
                                                                    <button mat-icon-button matSuffix type="button" *ngIf="rowsPartsFa.at(idxRow_1).get('brandRefFc')?.value" style="height:100%;margin-top:30px" (click)="clearBrandRef(idxRow_1)">
                                                                        <mat-icon>close</mat-icon>
                                                                    </button>
                                                                </mat-form-field>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-1 d-flex justify-content-center align-items-center" style="height:100%;margin-top:30px;padding-left:0px;padding-right:0px;">
                                                        <div *ngIf="!rowsParts[idxRow_1]?.isFound">
                                                            <button *ngIf="rowsParts[idxRow_1]?.toCreate" mat-icon-button type="button" (click)="addReference(idxRow_1)" [disabled]="isReadOnly">
                                                                <i class="fa fa-plus"></i>
                                                            </button>
                                                            <button *ngIf="!rowsParts[idxRow_1]?.toCreate" mat-icon-button type="button" (click)="searchReference(idxRow_1)" [disabled]="isReadOnly">
                                                                <i class="fa fa-search"></i>
                                                            </button>
                                                        </div>
                                                    </div>

                                                    <div class="col-2">
                                                        <mat-form-field class="mdiinput form-group" appearance="standard">
                                                            <mat-label>{{ 'brandLabel' | translate }}</mat-label>
                                                            <input class="form-control inputTheme" formControlName="brandLabelFc" matInput required readonly>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-1">
                                                        <mat-form-field class="mdiinput form-group" appearance="standard">
                                                            <mat-label>{{ 'Id' | translate }}</mat-label>
                                                            <input class="form-control inputTheme text-center" formControlName="stockIdFc" matInput required readonly>
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-1">
                                                        <mat-form-field class="mdiinput form-group" appearance="standard">
                                                            <mat-label>{{ 'partQty' | translate }}</mat-label>
                                                            <input class="form-control inputTheme" formControlName="partQtyFc" matInput required style="text-align:right" (keypress)="numberAndDotOnly($event)" (keydown.enter)="handleEnter($event)" (focus)="unformatNumericField('partQty', idxRow_1)" (focusout)="formatNumericField('partQty', idxRow_1)">
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-1">
                                                        <mat-form-field class="mdiinput form-group" appearance="standard">
                                                            <mat-label>{{ 'supplierPackaging' | translate }}</mat-label>
                                                            <input class="form-control inputTheme" formControlName="supplierPackagingFc" matInput required style="text-align:right" (keypress)="numberAndDotOnly($event)" (keydown.enter)="handleEnter($event)" (focus)="unformatNumericField('supplierPackaging', idxRow_1)" (focusout)="formatNumericField('supplierPackaging', idxRow_1)">
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-1">
                                                        <mat-form-field class="mdiinput form-group" appearance="standard">
                                                            <mat-label>{{ 'partPurchase' | translate }}</mat-label>
                                                            <input class="form-control inputTheme" formControlName="partPurchaseFc" 
                                                                matInput style="text-align:right" 
                                                                (keypress)="numberAndDotOnly($event)" 
                                                                (keydown.enter)="handleEnter($event)" 
                                                                (focus)="unformatNumericField('partPurchase', idxRow_1)" 
                                                                (focusout)="formatNumericField('partPurchase', idxRow_1)">
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-1">
                                                        <mat-form-field class="mdiinput form-group" appearance="standard">
                                                            <mat-label>{{ 'coef' | translate }}</mat-label>
                                                            <input class="form-control inputTheme" formControlName="coefFc" 
                                                                matInput required style="text-align:right" 
                                                                (keypress)="numberAndDotOnly($event)" 
                                                                (keydown.enter)="handleEnter($event)" 
                                                                (focus)="unformatNumericField('coef', idxRow_1)" 
                                                                (focusout)="formatNumericField('coef', idxRow_1)">
                                                        </mat-form-field>
                                                    </div>

                                                    <div class="col-1">
                                                        <mat-form-field class="mdiinput form-group" appearance="standard">
                                                            <mat-label>{{ 'partSelling' | translate }}</mat-label>
                                                            <input class="form-control inputTheme" formControlName="partSellingFc" matInput style="text-align:right" (keypress)="numberAndDotOnly($event)" (keydown.enter)="handleEnter($event)" (focus)="unformatNumericField('partSelling', idxRow_1)" (focusout)="formatNumericField('partSelling', idxRow_1)">
                                                        </mat-form-field>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </mat-card-content>
                </mat-card>
            </form>
        </div>
    </div>
</ng-template>